import React, { useEffect, useMemo } from 'react';

import useWindowSize from '@hooks/useWindowSize';
import { WIDTH_MD } from '@utils/constants';

import { LeadCaptureModalBodyProps } from '../../LeadCaptureModalBody';
import { ModalHeaderProps } from '../../common/modalHeader';
import ModalHeaderSection from './ModalHeaderSection';
import OfferSelectionFormSection from './OfferSelectionFormSection';

export type LeadCaptureModalWithMultipleSubscribeOptionsProps = ModalHeaderProps &
  LeadCaptureModalBodyProps;

export interface FormValues {
  selectedOffer: string;
}

const LeadCaptureModalWithMultipleSubscribeOptions = ({
  highlight,
  buttonText = 'Get Started',
  closeIconRef,
  leadType,
  title,
  subtitle,
  proOfferCode,
  annualOfferCode,
}: LeadCaptureModalWithMultipleSubscribeOptionsProps) => {
  const { width: windowWidth } = useWindowSize();
  const isMediumOrSmallScreen = useMemo(() => windowWidth <= WIDTH_MD, [windowWidth]);

  useEffect(() => {
    if (closeIconRef?.current) {
      closeIconRef.current.style.color = isMediumOrSmallScreen ? 'white' : 'black';
    }
  }, [isMediumOrSmallScreen, closeIconRef]);

  return (
    <div className="flex min-h-full w-full flex-wrap">
      <ModalHeaderSection highlight={highlight} title={title} subtitle={subtitle} />
      <OfferSelectionFormSection
        proOfferCode={proOfferCode}
        annualOfferCode={annualOfferCode}
        buttonText={buttonText}
        leadType={leadType}
      />
    </div>
  );
};

export default LeadCaptureModalWithMultipleSubscribeOptions;
